var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rules"},[_c('p',[_vm._v("发票须知")]),_vm._l((_vm.rules),function(item,index){return _c('p',{key:index},[_vm._v(" "+_vm._s(item.title)+" "),_vm._l((item.child),function(ele,i){return _c('span',{key:i},[_vm._v(" "+_vm._s(ele.childTitle)+" ")])})],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }